module.exports = __webpack_public_path__ + "static/img/icon_partner_ikea.6f6cad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_ikea.png
// module id = pwLU
// module chunks = 1